import get from 'lodash/get';
import { action, autorun, computed, makeObservable, observable } from 'mobx';

import { postRequest } from '../../services/api';
import type { ApiResponse } from '../../services/types';
import { devError } from '../../utils/log';
import type { RootStore } from '../RootStore';

import { CONFIG_KEYS, CONFIG_ROUTE } from './constants';

export class ConfigStore {
  private readonly rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this);

    autorun(() => {
      void this.fetchConfigs();
    });
  }

  @observable
  public isConfigFetched = false;

  @observable
  public configs: Record<string, any> = {};

  @action
  private setIsConfigFetched(state: boolean) {
    this.isConfigFetched = state;
  }

  @action
  private setConfigs(configs: Record<string, any>) {
    this.configs = configs;
  }

  @computed
  public get lowBalanceCcThreshold() {
    return get(this.configs, 'low_balance_cc_threshold', 0);
  }

  public async fetchConfigs() {
    try {
      const configKeys = CONFIG_KEYS;
      const response = await postRequest<ApiResponse<Record<string, any>>>(CONFIG_ROUTE, {
        configKeys,
      });
      this.setConfigs(get(response, 'data.data', {}));
    } catch (error) {
      devError('Failed to fetch configs', error);
    }
    this.setIsConfigFetched(true);
  }
}
